<template>
  <div class="tabs">
    <div
      :class="{ tab: true, active: tab.value === $route.name }"
      v-for="tab in tabs"
      :key="tab.id"
      :data-testid="tab.label"
      @click="$emit('selectTab', tab.value)"
    >
      {{ $t(tab.label) }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Tabs',
  props: ['tabs']
})
export default class TabsComponent extends Vue {}
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  display: flex;
  padding-left: 24px;
  padding-right: 24px;
  column-gap: 40px;
  .tab {
    position: relative;
    color: $label;
    font-size: $thirteenSize;
    text-align: center;
    padding-bottom: 10px;
    margin-bottom: 6px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &.active {
      color: $main-green;
      font-family: 'Ubuntu-Medium';
      &::before {
        position: absolute;
        content: '';
        bottom: -6px;
        left: 50%;
        width: 22px;
        height: 1px;
        background: $main-green;
        transform: translateX(-50%);
      }
    }
  }
  &::before {
    position: absolute;
    content: '';
    bottom: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background-color: $ligher-grey;
  }
}
</style>
